/**
 * Extracts a message from the `{ error: { message } }` envelope. ts-rest types a
 * non-2xx body as `unknown`, so narrow with a guard (no cast); falls back to `fallback`.
 */
export function getErrorMessage(body: unknown, fallback: string): string {
  if (
    typeof body === 'object' &&
    body !== null &&
    'error' in body &&
    typeof body.error === 'object' &&
    body.error !== null &&
    'message' in body.error &&
    typeof body.error.message === 'string'
  ) {
    return body.error.message;
  }
  return fallback;
}
